// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__3kb72","img":"recipe_img__2swQC"};